import {
  BroadcastEventType,
  ConnectionStatus,
} from '@/resources/enums/websocket'
import { Interval, Timeout } from '@/resources/types/websocket'
import { isTestEnvironment } from '@/resources/utils'

export const WEBSOCKET_LEADER_KEY = 'websocket_leader'
export const BROADCAST_CHANNEL = 'websocket_channel'
export const TAB_ID = 'tab_id'

export const MAX_RETRIES = 2
export const LEADER_INTERVAL = 5000
export const LEADER_TIMEOUT = 8000
export const RETRY_TIME = 3000

export const TEST_ENV_URL = 'ws://test-url'

export const getWebSocketUrl = () => {
  if (isTestEnvironment) {
    return TEST_ENV_URL
  }
  return process.env.ORDERS_WEBSOCKET_URL
}

export const getTabId = (): string => {
  let tabId = sessionStorage.getItem(TAB_ID)
  if (!tabId) {
    tabId = `tab_${Date.now()}_${Math.floor(Math.random() * 1000)}`
    sessionStorage.setItem(TAB_ID, tabId)
  }
  return tabId
}

export const updateLeaderTabOnStorage = (tabId: string) => {
  localStorage.setItem(WEBSOCKET_LEADER_KEY, tabId)
}

export const removeLeaderTabFromStorage = () => {
  localStorage.removeItem(WEBSOCKET_LEADER_KEY)
}

export const getLeaderTabFromStorage = () =>
  localStorage.getItem(WEBSOCKET_LEADER_KEY)

export const broadcastOrders = (
  channel: BroadcastChannel,
  payload: string,
  tabId: string
) => {
  channel.postMessage({
    type: BroadcastEventType.MESSAGE,
    payload,
    tabId,
  })
}

export const requestConnectionState = (
  channel: BroadcastChannel,
  tabId: string
) => {
  channel.postMessage({ type: BroadcastEventType.REQUEST_STATE, tabId })
}

export const sendConnectionStatus = (
  channel: BroadcastChannel,
  status: ConnectionStatus,
  tabId: string
) => {
  channel.postMessage({
    type: BroadcastEventType.CONNECTION_STATUS,
    status,
    tabId,
  })
}

export const getLeaderIsAliveInterval = (
  channel: BroadcastChannel,
  isLeader: boolean,
  tabId: string
) =>
  setInterval(() => {
    if (isLeader) {
      channel.postMessage({ type: BroadcastEventType.LEADER_IS_ALIVE, tabId })
    }
  }, LEADER_INTERVAL)

export const getFollowerTabTimeout = (callback: () => void) =>
  setTimeout(() => callback(), LEADER_TIMEOUT)

export const getRetryTimeout = (isLeader: boolean, connect: () => void) =>
  setTimeout(() => {
    if (isLeader) connect()
  }, RETRY_TIME)

export const removeInterval = (interval?: Interval) => {
  if (interval) {
    clearInterval(interval)
    interval = null
  }
}

export const removeTimeout = (timeout?: Timeout) => {
  if (timeout) {
    clearTimeout(timeout)
    timeout = null
  }
}

export const clearAllTimers = (
  leaderInterval?: Interval,
  leaderTimeout?: Timeout,
  retryTimeout?: Timeout
) => {
  removeInterval(leaderInterval)
  removeTimeout(leaderTimeout)
  removeTimeout(retryTimeout)
}

export const closeWebSocket = (webSocket: WebSocket | null) => {
  if (webSocket) {
    webSocket.close()
    webSocket = null
  }
}
